module.exports = __webpack_public_path__ + "img/logo.945ce761.svg";